import Action from '../Action';
import HomeBannerService from '../../services/HomeBannerService';
import { message } from 'antd';

export function fetchSliderImages() {
	return (dispatch) => {
		HomeBannerService.getAll()
			.then((sliderImages) => dispatch({ type: Action.FETCH_SLIDER_IMAGE, sliderImages: sliderImages.data }))
			.catch((error) => message.error('Failed to fetch slider image!'));
	};
}

export function fetchActiveSliderImages() {
	return (dispatch) => {
		HomeBannerService.getActive()
			.then((sliderImages) =>
				dispatch({ type: Action.FETCH_ACTIVE_SLIDER_IMAGE, activeSliderImages: sliderImages.data })
			)
			.catch((error) => message.error('Failed to fetch slider image!'));
	};
}

export function addSliderImage(body) {
	return (dispatch) => {
		HomeBannerService.add(body)
			.then((sliderImage) => {
				dispatch({ type: Action.POST_SLIDER_IMAGE, sliderImage: sliderImage.data });
				message.success('Slider Image Added');
			})
			.catch((error) => message.error('Failed to add slider image!'));
	};
}

export function updateSliderImage(id, body) {
	return (dispatch) => {
		HomeBannerService.update(id, body)
			.then((sliderImage) => {
				dispatch({ type: Action.UPDATE_SLIDER_IMAGE, sliderImage: sliderImage.data });
				message.success('Slider Image Updated');
			})
			.catch((error) => message.error('Failed to update slider image!'));
	};
}

export function updateSliderImageStatus(id, body) {
	return (dispatch) => {
		HomeBannerService.updateStatus(id, body)
			.then((sliderImage) => {
				dispatch({ type: Action.UPDATE_SLIDER_IMAGE_STATUS, sliderImage: sliderImage.data });
				message.success('Slider Image Status Updated');
			})
			.catch((error) => message.error('failed to update slider image!'));
	};
}

export function updateSliderImageMobile(id, body) {
	return (dispatch) => {
		HomeBannerService.updateMobileImage(id, body)
			.then((sliderImage) => {
				dispatch({ type: Action.UPDATE_SLIDER_IMAGE_MOBILE, sliderImage: sliderImage.data });
				message.success('Slider Image Updated');
			})
			.catch((error) => message.error('Failed to update slider image!'));
	};
}

export function updateSliderImageWeb(id, body) {
	return (dispatch) => {
		HomeBannerService.updateWebImage(id, body)
			.then((sliderImage) => {
				dispatch({ type: Action.UPDATE_SLIDER_IMAGE_WEB, sliderImage: sliderImage.data });
				message.success('Slider Image Updated');
			})
			.catch((error) => message.error('Failed to update slider image!'));
	};
}

export function deleteSliderImage(id) {
	return (dispatch) => {
		HomeBannerService.delete(id)
			.then((sliderImage) => {
				dispatch({ type: Action.DELETE_SLIDER_IMAGE, sliderImage: sliderImage.data });
				message.success('Slider Image Deleted');
			})
			.catch((error) => message.error('Failed to delete slider image!'));
	};
}
